<template>
    <table v-if="tableObject">
        <caption v-if="tableObject.table_caption">{{ tableObject.table_caption }}</caption>
        <tr v-if="tableObject.first_row_is_table_header">
            <th v-for="mth,idx in headerColumns" scope="col" v-bind:key="idx">{{ mth }}</th>
        </tr>
        <tr v-for="mtr,idx in dataRows" v-bind:key="idx">
            <template v-if="tableObject.first_col_is_header">
                <th scope="row">{{ mtr[0] }}</th>
                <td v-for="mtd,mtdidx in mtr.slice(1)" v-bind:key="mtdidx">{{ mtd }}</td>
            </template>
            <template v-else>
                <td v-for="mtd,mtdidx in mtr" v-bind:key="mtdidx">{{ mtd }}</td>
            </template>
        </tr>
    </table>
</template>

<script>

export default {
    name: 'TableSnippet',
    data() {
        return {
        }
    },
    props: {
        tableObject: {
            type: Object,
            default() { return {};} 
        },
    },
    methods: {
        init() {

        },

    },
    mounted() {
        this.init();
    },
    computed: {
        dataRows() {
            if (!this.tableObject) { return []; }
            if (this.tableObject.first_row_is_table_header) {
                return this.tableObject.data.slice(1);
            }
            return this.tableObject.data;
        },
        headerColumns() {
            if (!this.tableObject) { return []; }
            if (this.tableObject.first_row_is_table_header) {
                return this.tableObject.data.slice(0, 1)[0];
            }
            return [];
        }
    }
}

</script>
